import { StyleSheet, TouchableOpacity, View } from "react-native"

import Ionicons from "@expo/vector-icons/Ionicons"

import type { NavigationControlsConfig } from "./types"

interface NavigationControlsProps {
  config: NavigationControlsConfig
}

/**
 * NavigationControls - Built-in navigation controls for web browser
 *
 * Features:
 * - Back button
 * - Forward button
 * Both buttons are disabled when navigation is not available
 */
export function NavigationControls({ config }: NavigationControlsProps) {
  const { canGoBack, canGoForward, onGoBack, onGoForward } = config

  return (
    <View style={styles.container}>
      <TouchableOpacity
        onPress={onGoBack}
        style={[styles.navButton, !canGoBack && styles.navButtonDisabled]}
        disabled={!canGoBack}
        accessibilityRole="button"
        accessibilityLabel="Go back"
      >
        <Ionicons
          name="caret-back"
          size={32}
          color={canGoBack ? "#FFFFFF" : "rgba(255,255,255,0.4)"}
        />
      </TouchableOpacity>
      <TouchableOpacity
        onPress={onGoForward}
        style={[styles.navButton, !canGoForward && styles.navButtonDisabled]}
        disabled={!canGoForward}
        accessibilityRole="button"
        accessibilityLabel="Go forward"
      >
        <Ionicons
          name="caret-forward"
          size={32}
          color={canGoForward ? "#FFFFFF" : "rgba(255,255,255,0.4)"}
        />
      </TouchableOpacity>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    gap: 12,
  },
  navButton: {
    width: 56,
    height: 56,
    borderRadius: 28,
    backgroundColor: "#303030", // This is hardcoded because it's a built-in control
    justifyContent: "center",
    alignItems: "center",
  },
  navButtonDisabled: {
    opacity: 0.5,
  },
})
